module.exports = __webpack_public_path__ + "img/gustavo-lima-lg.c9f9701e.png";